import React from 'react';
import Currency, {formatDualCurrencyPrice} from '@ampeco/currency';
import {__} from '@ampeco/i18n';
import PriceRow from '../../PriceRow';
import {PeakPowerLevel} from '@ampeco/charge-models';
import {PricingHeader} from '@ampeco/charge-screens';
interface Props {
    powerLevels: PeakPowerLevel[];
    currency: Currency;
    operatorCountry: string | null;
    regularUseMinutes: number | null;
}
const PeakPowerLevelsPrices: React.FC<Props> = (props: Props) => {
    return (
        props.powerLevels.map((level, levelId) => {

            return <React.Fragment key={'powerlevel-' + levelId}><PricingHeader padTop>{levelId < props.powerLevels.length - 1
                ? __('session.start.pricing.peak-up-to').replace('{peakPowerKw}', Number.parseFloat(level.peakPowerUpToKw.toString()).toFixed(2).toString())
                : __('session.start.pricing.peak-above').replace('{peakPowerKw}', Number.parseFloat(props.powerLevels[levelId - 1].peakPowerUpToKw.toString()).toFixed(2).toString())
            }</PricingHeader>
                <PriceRow label={__('session.start.pricing.regular')} value={formatDualCurrencyPrice({
                    amount: level.regularPricePerMinute,
                    currencyId: props.currency?.id,
                    operatorCountry: props.operatorCountry,
                })} />
                <PriceRow label={__('session.start.pricing.excess').replace('{minutes}', props.regularUseMinutes ? props.regularUseMinutes.toString() : '')} value={formatDualCurrencyPrice({
                    amount: level.excessUsePricePerMin,
                    currencyId: props.currency?.id,
                    operatorCountry: props.operatorCountry,
                })} />
            </React.Fragment>;
        }))
}

export default PeakPowerLevelsPrices;
